<form class="event-form" [formGroup]="eventForm()">
  <mat-radio-group formControlName="paymentType">
    <mat-radio-button [value]="EventPaymentEnum.CARD_ONLY"
      >Online</mat-radio-button
    >
    <mat-radio-button [value]="EventPaymentEnum.CASH_ONLY"
      >Cash</mat-radio-button
    >
    <mat-radio-button [value]="EventPaymentEnum.CASH_AND_CARD"
      >Both</mat-radio-button
    >
  </mat-radio-group>

  @if (paymentType?.value !== EventPaymentEnum.CARD_ONLY) {
    <div>
      <br />
      <i
        >To enable Cash or In-person Payments, you authorize a ${{
          EVENT_DAILY_COST
        }}
        per day charge for the duration of the event.</i
      >
      <br />
      <br />
      <b>Event cost: ${{ eventCost().toFixed(2) }}</b>
      @if (isEventPaid()) {
        <div class="event-form__paid">This event is paid in full</div>
      } @else {
        <div class="event-form__not-paid">
          Pending payment of ${{ eventUpcomingCharge().toFixed(2) }}
        </div>
      }
    </div>
    @if (!isEventPaid()) {
      <br />
      <div id="stripe-event-payment-element">
        <mat-spinner class="stripe-spinner"></mat-spinner>
      </div>
    }
    @if ((stripeError()() || eventForm().invalid) && submitted()) {
      <mat-error>
        <strong>There is something wrong with your message</strong>
        @if (stripeError()()) {
          <div>
            {{ stripeError()()?.message }}
          </div>
        }
      </mat-error>
    }
  }
</form>
